<div class="wrap-dashboard">
    
  
    <div class="wrap-center-body">
        <div class="grid mb-4" >
            <div class="col-12 lg:col sm:col-12 sm:mb-2">
                <h1 class="h4 m-0">{{'Dashboard Overview' | sentenceCase}}</h1>
            </div>
            <div class="col-12 lg:col sm:col-12 flex xl:justify-content-end justify-content-between mt-3 md:mt-0 align-items-start lg:align-items-center  md:gap-3 gap-2 lg:flex-row flex-column">
              @if(reviewer){
                <div *ngIf="showAvailableButton && reviewer.role !== 'CANDIDATE'" class="reduce-bottom-space margin-top-minus-6">
                  <div class="row">
                      <div class="col-md-12">
                          <div class="d-flex">
                              <div class="flex flex-row padding-right-ten top-ten">
                                  <!-- Tooltip when the user is not marked available -->
                                  @if(!reviewer.isMarkedAvailable){
                                    <span class="info-markavailable text-primary-700 margin-right flex {{helperService.getEnvironmentName()}}-icon icon-info-outlined cursor-pointer fs-small"
                                    [pTooltip]="'Let ' + currentFirm.firm.name + ' know that you are actively available and interested in receiving offers for upcoming jobs'" tooltipPosition="bottom"></span>
                                  }

                                  @if(reviewer.isMarkedAvailable){
                                    <span class="info-markavailable text-primary-700 margin-right flex {{helperService.getEnvironmentName()}}-icon icon-info-outlined cursor-pointer fs-small"
                                     [pTooltip]="'You have already conveyed your availability to ' + currentFirm.firm.name + '. Make sure to check back in at the beginning of each week to mark yourself available'" tooltipPosition="bottom"></span>
                                  }
                                  <div  class="flex md:gap-3 gap-2">
                                    <p-button [label]="!reviewer.isMarkedAvailable ? 'I Am Available' : 'Available'" [disabled]="reviewer.isMarkedAvailable" (onClick)='markAvailable()'[rounded]="true" styleClass="white-space-nowrap vibrant-pink-background" />
                                    <p-divider layout="vertical" styleClass="py-2" />
                                  </div>
                              </div>                          
                          </div>
                      </div>
                  </div>
              
                  <!-- Display last updated date -->
                  <span class="info-markavailable last-updated fs-small" *ngIf="reviewer.markedAvailableAt">
                    <strong>Last Updated:</strong> <br>{{ reviewer.markedAvailableAt | date:'MMMM, dd yyyy' }} {{ reviewer.markedAvailableAt | date:'hh:mm a' }}
                  </span>
                </div>
              }
              
                @if(getCurrentPositions().length && currentFirm.firm.payroll.enabled && selectedCurrentPosition.project.tsheet.isEnabled){
                  <div class="flex md:gap-3 gap-2 xl:flex-row lg:flex-row flex-column">
                    <span class="h4">{{dailyDuration?.hours}}:{{dailyDuration?.minutes}}:{{dailyDuration?.seconds}}</span>  
                    @if(this.roles){
                      @if(!isClockedIn){
                        <p-button (onClick)="showRolesModal($event)" label="start time" [rounded]="true" styleClass="teal white-space-nowrap" />
                      }@else{
                        <p-button (onClick)="clockOut()" label="end time" [rounded]="true" styleClass="red-background white-space-nowrap" />
                      }
                    }
                    <p-button label="go to timekeeping" (click)="goToTimekeeping()" [rounded]="true" class="white-space-nowrap" />
                  </div>
                }
            </div>
        </div>
        <div class="grid">
            <div class="col-12 lg:col-12 xl:col-8 sm:col-12">
              @if(reviewer){
                <p-panel styleClass="mb-4">
                  <ng-template pTemplate="content">
                      <div class="grid grid-nogutter px-2">
                          <div class="col-12 md:col-6 flex flex-column">
                              <h6 class="mt-1 mb-2">{{reviewer.firstName}} {{reviewer.lastName}}</h6>
                              <span *ngIf="reviewer.profile && reviewer.profile.contact" class="text-sm font-medium">
                                @if(!isPWCEnabled){
                                  {{reviewer.profile.contact.street}},
                                }
                                {{reviewer.profile.contact.city}}, {{reviewer.profile.contact.state}}
                              </span>
                          </div>
                          <div class="col-12 md:col-6 flex flex-column">
                              <div class="flex flex-column gap-2 mb-2">
                                  <p-progressBar [style]="{ height: '4px' }" [value]="profileStrengthValue" />
                                  <span class="text-xs">Your profile is {{profileStrengthValue}}% completed.</span>
                              </div>
                              <div class="flex flex-column md:flex-row md:align-items-center justify-content-between gap-2">
                                <div class="flex gap-3 md:gap-5 align-items-center flex-wrap flex-1 p-0">
                                  @if(currentFirm.firm.isEducationRequired){
                                    <span pTooltip="Education" tooltipPosition="top" class="{{helperService.getEnvironmentName()}}-icon icon-school-outlined cursor-pointer" [ngClass]="{ 'profile-icon': profileStrength.education}" (click)="goto('/reviewer/profile/education')"></span>
                                  }
                                  <span [pTooltip]="'Resume and Certifications' | sentenceCase" tooltipPosition="top" class="{{helperService.getEnvironmentName()}}-icon icon-file-present-outlined cursor-pointer" [ngClass]="{ 'profile-icon': profileStrength.document}" (click)="goto('/reviewer/profile/resume')"></span>
                                  @if(credentials && credentials.length){
                                    <span pTooltip="Credentials" tooltipPosition="top" class="{{helperService.getEnvironmentName()}}-icon icon-password-outlined cursor-pointer" [ngClass]="{ 'profile-icon': profileStrength.credentials}" (click)="goto('/reviewer/profile/credentials')"></span>
                                  }
                                  @if(skillsAndExperience && skillsAndExperience.length){
                                    <span [pTooltip]="'Skills and Experience' | sentenceCase " tooltipPosition="top" class="{{helperService.getEnvironmentName()}}-icon icon-settings-accessibility-outlined cursor-pointer" [ngClass]="{ 'profile-icon': profileStrength.skill }" (click)="goto('/reviewer/profile/skills')"></span>
                                  }
                                  <span [pTooltip]="'Account Settings' | sentenceCase" tooltipPosition="top" class="{{helperService.getEnvironmentName()}}-icon icon-settings-outlined cursor-pointer" [ngClass]="{ 'profile-icon': profileStrengthValue === 100}" (click)="goto('/reviewer/settings')"></span>
                                </div>
                                <div class="flex justify-content-end p-0 md:pl-2">
                                  <p-button (click)="navigateToProfile()" [link]="true" styleClass="p-0 " label="edit profile"></p-button>
                                </div>
                              </div>
                          </div>
                      </div>
                  </ng-template>
                </p-panel>
              }
                <p-panel>
                  <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event,activeTabIndex)">
                    <p-tabPanel>
                        <ng-template pTemplate="header">
                          <span class="mx-0 lg:mx-3 xl:mx-3"><span>To</span>&nbsp;<span>do</span>&nbsp;<span>list</span> </span>&nbsp; <p-badge class="flex right" [value]="toDoList.length" severity="primary"></p-badge>
                        </ng-template>
                          <div>
                              @if(getCurrentPositions().length > 0) {
                              <p-dropdown [(ngModel)]="selectedCurrentPosition" optionLabel="name" [options]="getCurrentPositions()"
                                [placeholder]="'Select Role' | sentenceCase" (onChange)="getTsheetList(getCurrentWeek(),selectedCurrentPosition)" />
                              }
                              <div *ngIf="loading" class="pt-4 pl-3 text-center"> 
                                  <p-progressSpinner [style]="{ width: '50px' }" ariaLabel="loading" />
                              </div>
                              @if(!toDoList.length && !loading){
                                <div class="pt-4 pl-3"> 
                                  You're all caught up! 
                                </div>  
                              }
                              @if(toDoList.length && !loading){
                                <p-dataView>
                                  <ng-template pTemplate="empty">
                                      <div class="grid grid-nogutter">
                                        @for(list of toDoList; track list){
                                          <div class="col-12">
                                              <div class="flex flex-column sm:flex-row sm:align-items-center py-3 gap-3  border-bottom-1 surface-border">
                                                  <div class="flex flex-column md:flex-row justify-content-between md:align-items-start flex-1 gap-4">
                                                      <div class="flex flex-row md:flex-column justify-content-between align-items-start gap-2 grid grid-nogutter">
                                                          <div class="col-12">
                                                              <div class="text-sm text-primary font-medium mt-1">{{list.header}}</div>
                                                              <p class="text-sm m-0 " style="white-space: pre-line;">{{list.body}}
                                                              </p>
                                                          </div>
                                                          <div class="col-12">
                                                            @if (list.checkedItems && list.checkedItems.length) {
                                                              <div class="flex flex-row align-items-start gap-3">
                                                                @for (item of list.checkedItems; track $index) {
                                                                  <div class="mb-2 checkbox-label-wrapper">
                                                                    <p-checkbox 
                                                                        [(ngModel)]="item.value"
                                                                        [binary]="true"
                                                                        [disabled]="true"
                                                                        inputId="item-{{item.value}}">
                                                                    </p-checkbox>
                                                                    <label [for]="'item-' + item.value" class="ml-2 text-sm">{{ item.label }}</label>
                                                                  </div>
                                                                }
                                                              </div>
                                                            }
                                                          </div>
                                                          <div class="col-12">
                                                            @if (list.actions.length) {
                                                              <div class="flex flex-row align-items-start gap-3">
                                                                @for (button of list.actions; track $index) {
                                                                  <p-button (click)="button.link()" [link]="true" styleClass="p-0" label="{{button.label}}"></p-button>
                                                                }
                                                              </div>
                                                            }
                                                          </div>
                                                      </div>
                                                      @if (list.createdAt) {
                                                        <div class="flex md:align-items-end gap-1 text-xs text-black-alpha-60 flex-nowrap white-space-nowrap">
                                                          <span class="font-semibold">{{list.createdAt | date:'hh:mm a' }}</span>
                                                          <span> | </span>
                                                          <span>{{list.createdAt | date:'MMMM, dd' }}</span>
                                                        </div>
                                                      }
                                                  </div>
                                              </div>
                                          </div>
                                        }
                                      </div>
                                  </ng-template>
                                </p-dataView>
                              }
                          </div>
                    </p-tabPanel>
                    @if(getCurrentPositions().length > 0) {
                      <p-tabPanel>
                          <ng-template pTemplate="header">
                            <span class="mx-0 lg:mx-3 xl:mx-3"><span>{{ isPWCEnabled ? 'Active' : 'Current' }}</span>&nbsp;<span>{{ isPWCEnabled ? 'projects' : 'jobs' }}</span> </span>
                          </ng-template>
                          <div class="flex flex-column gap-4">
                              <p-dropdown [(ngModel)]="selectedCurrentPosition"  optionLabel="name" [options]="getCurrentPositions()"
                                  placeholder="Select Role" (onChange)="getTsheetList(getCurrentWeek(),selectedCurrentPosition)" />
                              <p-button (onClick)="navigateToMessages(selectedCurrentPosition)" [rounded]="true" size="small" label="messages"></p-button>
                              @if(selectedCurrentPosition){
                                <app-job-info
                                  [isPWCEnabled]="isPWCEnabled"
                                  [isPwcPresumptive]="isPwcPresumptive(selectedCurrentPosition.project)"
                                  [job]="selectedCurrentPosition"
                                  [jobLocation]="currentLocation"
                                  [getFixedValueDigits]="getFixedValueDigits"
                                  [getFormattedNumber]="getFormattedNumber"
                                ></app-job-info>
                                <div class="flex flex-column gap-3">
                                    <div *ngIf="selectedCurrentPosition.project.tsheet.isEnabled && enableTimeTrackerGraph && currentFirm.firm.payroll.enabled" class="mp-tab-detail-container">
                                      <span class="text-sm font-medium">{{'Candidate Hours' | sentenceCase}}</span>
                                      <h3 class="cursor-pointer">{{'Time Tracker' | sentenceCase}}</h3>
                                      <div class="mp-graph-section">
                                        <div class="flex lg:flex-row xl:flex-row gap-3 flex-column">
                                          <h6>Daily:</h6>                                      
                                              <span *ngIf="dailyDuration"> {{ dailyDuration.hours }}:{{ dailyDuration.minutes }}:{{ dailyDuration.seconds }}</span>
                                            
                                              <h6>{{'Last 2 Weeks:' | sentenceCase}}</h6>
                                              <span *ngIf="weekDuration">{{ weekDuration.hours }}:{{ weekDuration.minutes }}</span>
                                            
                                              <h6>Total: </h6>
                                              <span *ngIf="totalDuration">{{ totalDuration.hours }}:{{ totalDuration.minutes }}</span>
                                            
                                        </div>
                                        <div class="chart">
                                          <app-chart 
                                            chartHeight="600px"
                                            [datasets]="graphData" 
                                            [labels]="graphLabels" 
                                            >
                                          </app-chart>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                                <div class="flex justify-content-between gap-2 md:flex-row flex-column-reverse">
                                    <p-button [rounded]="true" size="small" severity="danger" (click)="quitPosition(selectedCurrentPosition)" label="end role"></p-button>
                                    <div class="flex gap-2">
                                        @if(currentFirm.firm.payroll.enabled && selectedCurrentPosition.project.tsheet.isEnabled){
                                          <p-button [rounded]="true" size="small" (click)="onViewTimeSheet(selectedCurrentPosition)" styleClass="teal" label="timekeeping"></p-button>
                                        }
                                        @if(documentsExist() || (this.selectedCurrentPosition.firm.isDocusignEnabled && this.selectedCurrentPosition.docusignEnabled)){
                                          <p-button (onClick)="openViewDocumentsModal()" [rounded]="true" [outlined]="true" size="small" label="view documents"></p-button>
                                        }
                                    </div>
                                </div>
                              }
                            </div>
                          </p-tabPanel>
                    }
                    @if(getFuturePositions().length){
                            <p-tabPanel header="header">
                              <ng-template pTemplate="header">
                                <span class="mx-0 lg:mx-3 xl:mx-3"><span>Future</span>&nbsp;<span>{{ isPWCEnabled ? 'projects' : 'jobs' }}</span> </span>
                              </ng-template>
                                <div class="flex flex-column gap-4">
                              <p-dropdown [(ngModel)]="selectedFuturePosition" optionLabel="name" [options]="getFuturePositions()"
                                  placeholder="Select Position" (onChange)="onChangeFuturePosition(getCurrentWeek(),selectedFuturePosition)" class="w-full" />
                              <p-button (onClick)="navigateToMessages(selectedFuturePosition)" [rounded]="true" size="small" label="messages"></p-button> 
                            @if(selectedFuturePosition){
                              <app-job-info
                                [isPWCEnabled]="isPWCEnabled"
                                [isPwcPresumptive]="isPwcPresumptive(selectedFuturePosition.project)"
                                [job]="selectedFuturePosition"
                                [jobLocation]="futureLocation"
                                [getFixedValueDigits]="getFixedValueDigits"
                                [getFormattedNumber]="getFormattedNumber"
                              ></app-job-info>
                              <div class="flex flex-column gap-3">          
                              </div>
                              <div class="flex justify-content-between gap-2 md:flex-row flex-column-reverse">
                                  <p-button [rounded]="true" (click)="quitPosition(selectedFuturePosition)" size="small" severity="danger" label="end role"></p-button>
                                  <div class="flex gap-2">
                                    @if(documentsExist(this.selectedFuturePosition) || (this.selectedFuturePosition.firm.isDocusignEnabled && this.selectedFuturePosition.docusignEnabled)){
                                      <p-button (onClick)="openViewDocumentsModal(this.selectedFuturePosition)" [rounded]="true" [outlined]="true" size="small" label="view documents"></p-button>
                                    }
                                  </div>
                              </div>
                            }
                          </div>
                      </p-tabPanel>
                    }
                    @if(pendingJobs && pendingJobs.length){
                      <p-tabPanel>
                        <ng-template pTemplate="header">
                          <span class="mx-0 lg:mx-3 xl:mx-3">{{isPWCEnabled ? 'Pending projects' : 'Pending jobs'}}</span>
                        </ng-template>
                        <div class="pending-jobs">
                          @if(!isPWCEnabled){
                            <div class="pt-4 mb-2 pl-2 pb-3 heading">You’ve been submitted for this job and are awaiting final approval from {{
                              currentFirm && currentFirm.firm && currentFirm.firm.name }}. Notifications will be sent to you as soon
                              as a decision is made. 
                            </div>
                          } @else if(selectedPendingJob ? isPwcPresumptivePosition(selectedPendingJob) : isPWCEnabled) {
                            <div class="pt-4 mb-2 pl-2 pb-3 heading">
                              Thanks for confirming your interest and availability for {{ selectedPendingJob?.project?.codeName || 'this project' }}. Your response has been submitted to the project team. We'll notify you once a decision has been made.
                            </div>
                          } @else {
                            <div class="pt-4 mb-2 pl-2 pb-3 heading">
                              You’ve been submitted for this project and are awaiting final approval from {{ currentFirm && currentFirm.firm && currentFirm.firm.name }}. Notifications will be sent to you as soon as a decision is made. 
                            </div>
                          }
                          <div class="flex flex-column gap-4">
                            <p-dropdown [(ngModel)]="selectedPendingJob" optionLabel="name" [options]="pendingJobs"
                              placeholder="Select Job" (onChange)="onChangePendingJobs(selectedPendingJob)" />
                            <p-button (onClick)="navigateToMessages(selectedPendingJob)" [rounded]="true" size="small" label="messages"></p-button>
                            @if(selectedPendingJob){
                            <app-job-info
                              [isPWCEnabled]="isPWCEnabled"
                              [isPwcPresumptive]="isPwcPresumptivePosition(selectedPendingJob)"
                              [job]="selectedPendingJob"
                              [jobLocation]="pendingJobLocation"
                              [getFixedValueDigits]="getFixedValueDigits"
                              [getFormattedNumber]="getFormattedNumber"
                            ></app-job-info>

                            <div class="flex flex-column gap-3">
                            </div>
                          }
                          </div>
                            <div class="flex justify-content-between gap-2 md:flex-row flex-column-reverse">
                              <p-button [rounded]="true" size="small" severity="danger" (click)="quitPosition(selectedPendingJob)" label="end role"></p-button>
                              <div class="flex gap-2">
                              @if(documentsExist(this.selectedPendingJob) && !this.selectedPendingJob.firm.isDocusignEnabled){
                                <p-button (onClick)="openViewDocumentsModal(this.selectedPendingJob)" [rounded]="true"
                                  [outlined]="true" size="small" label="view documents"></p-button>
                              }
                            </div>
                            </div>
                          </div>
                      </p-tabPanel>
                    }
                    @if(getMobileVisibility() && offers.length){
                      <p-tabPanel>
                        <ng-template pTemplate="header">
                          <span class="mx-0 lg:mx-3 xl:mx-3">Offers</span> &nbsp; <p-badge class="flex right" [value]="offers.length" severity="primary"></p-badge>
                        </ng-template>
                        <div class="job-offer">
                          @for(offer of offers; track offer){
                            <div class="flex flex-column gap-3">
                                <div class="px-3 py-4 mb-5 bg-white">
                                    <div class="grid justify-content-between">
                                        <div class="col-6 flex flex-column">
                                            <span class="text-xs text-primary">Role</span>
                                            <span class="text-sm font-medium">{{offer.role.roleType}}</span>
                                            
                                        </div>
                                        @if(offer?.role?.workSchedule?.workHours){
                                        <div class="col-6 flex flex-column">
                                            <span class="text-xs text-primary">Hours</span>
                                            <span class="text-sm font-medium">{{offer?.role?.workSchedule?.workHours}}</span>
                                        </div>
                                        }
                                        @if(!isPwcPresumptive(offer.project)){
                                        <div class="col-6 flex flex-column">
                                            <span class="text-xs text-primary">Rate</span>
                                            <span class="text-sm font-medium">${{getFixedValueDigits(offer.role.hourlyRate)}}/hr</span>
                                        </div>
                                        }
                                        @if(offer.role.overtime !== 0){
                                          <div class="col-6 flex flex-column">
                                            <span class="text-xs text-primary">Overtime</span>
                                            @if(offer.role.overTime){
                                              <span class="text-sm font-medium">${{offer.role.overTime}}/hr</span>
                                            } @else {
                                              <span class="text-sm font-medium">N/A</span>
                                            }
                                          </div>
                                        }
                                        <div class="col-6  flex flex-column">
                                            <span class="text-xs text-primary">{{'Start Date' | sentenceCase}}</span>
                                            <span class="text-sm font-medium">{{((offer.role.isStarted? offer.positionStarted : offer.role.startDate) | date:'MMM dd, YYYY') || 'Start date not finalized'}} </span>
                                            <span class="text-sm font-medium">{{(offer.role.isStarted? offer.positionStartedTime : offer.role.startTime) }}@if(offer.role.isStarted? offer.positionStartedTime : offer.role.startTime){ - {{offer.role.timezone}}}@else{}</span>
                                        </div>
                                        <div class="col-6 flex flex-column">
                                          <span class="text-xs text-primary">Address</span>
                                          @if(offer?.role?.reviewCenterLocation?.isRemote){
                                          <span class="text-sm font-medium">Remote</span>
                                          }@else{
                                            <span class="text-sm font-medium">{{offer?.role?.reviewCenterLocation?.reviewLocation?.location?.officeName+','}}</span>
                                            <span class="text-sm font-medium">{{offer?.role?.reviewCenterLocation?.reviewLocation?.location?.street+', '+    
                                            offer?.role?.reviewCenterLocation?.reviewLocation?.location?.suiteNo}}</span>
                                            <span class="text-sm font-medium">{{offer?.role?.reviewCenterLocation?.reviewLocation?.location?.city+', '+
                                            offer?.role?.reviewCenterLocation?.reviewLocation?.location?.state +', '+ offer?.role?.reviewCenterLocation?.reviewLocation?.location?.zipCode }}</span>
                                          }
                                          
                                         
                                      </div>
                                        <div class="col-6  flex flex-column">
                                            <span class="text-xs text-primary">Schedule</span>
                                            @if(offer?.role?.workSchedule?.schedule?.weekDays?.willWork){
                                              @if(isPWCEnabled){
                                                <span class="text-sm font-medium">M-F ({{ offer?.role?.workSchedule?.schedule?.weekDays?.generalSelectedHour }})</span>
                                                @if(offer?.role?.workSchedule?.schedule?.weekDays?.potentialWeekendHours){
                                                  <span class="text-sm font-medium">Potential weekend hours</span>
                                                }
                                              } @else {
                                                <span class="text-sm font-medium">M-F (
                                                  {{
                                                    offer?.role?.workSchedule?.schedule?.weekDays?.time?.start?.hour.toString().padStart(2, '0')
                                                  }}:{{
                                                    offer?.role?.workSchedule?.schedule?.weekDays?.time?.start?.min.toString().padStart(2, '0')
                                                  }}
                                                  {{
                                                    offer?.role?.workSchedule?.schedule?.weekDays?.time?.start?.meridiem
                                                  }}
                                                  --
                                                  {{ offer?.role?.workSchedule?.schedule?.weekDays?.time?.end?.hour.toString().padStart(2, '0') }}:{{
                                                    offer?.role?.workSchedule?.schedule?.weekDays?.time?.end?.min.toString().padStart(2, '0')
                                                  }}
                                                  {{ offer?.role?.workSchedule?.schedule?.weekDays?.time?.end?.meridiem }}
                                                )</span>
                                              }
                                            }
                                            @if(!isPWCEnabled && offer?.role.workSchedule.schedule.saturday.willWork){
                                              <span class="text-sm font-medium">SAT (
                                                {{
                                                  offer?.role?.workSchedule?.schedule?.weekDays?.time?.start?.hour.toString().padStart(2, '0')
                                                }}:{{
                                                  offer?.role?.workSchedule?.schedule?.weekDays?.time?.start?.min.toString().padStart(2, '0')
                                                }}
                                                {{
                                                  offer?.role?.workSchedule?.schedule?.weekDays?.time?.start?.meridiem
                                                }}
                                                --
                                                {{ offer?.role?.workSchedule?.schedule?.weekDays?.time?.end?.hour.toString().padStart(2, '0') }}:{{
                                                  offer?.role?.workSchedule?.schedule?.weekDays?.time?.end?.min.toString().padStart(2, '0')
                                                }}
                                                {{ offer?.role?.workSchedule?.schedule?.weekDays?.time?.end?.meridiem }}
                                              )</span>
                                            }
                                            @if(!isPWCEnabled && offer?.role.workSchedule.schedule.sunday.willWork){
                                              <span class="text-sm font-medium">SUN (
                                                {{
                                                  offer?.role?.workSchedule?.schedule?.sunday?.time?.start?.hour.toString().padStart(2, '0')
                                                }}:
                                                {{
                                                  offer?.role?.workSchedule?.schedule?.sunday?.time?.start?.min.toString().padStart(2, '0')
                                                }}
                                                {{
                                                  offer?.role?.workSchedule?.schedule?.sunday?.time?.start?.meridiem
                                                }}
                                                --
                                                {{ 
                                                  offer?.role?.workSchedule?.schedule?.sunday?.time?.end?.hour.toString().padStart(2, '0')
                                                }}
                                                :
                                                {{
                                                  offer?.role?.workSchedule?.schedule?.sunday?.time?.end?.min.toString().padStart(2, '0')
                                                }}
                                                {{ 
                                                  offer?.role?.workSchedule?.schedule?.sunday?.time?.end?.meridiem 
                                                }}
                                              )</span>
                                            }
                                        </div>               
         
                            
                                        @if(offer.role.workSchedule.duration){
                                        <div class="col-6 flex flex-column">
                                            <span class="text-xs text-primary">Duration</span>
                                            <span class="text-sm font-medium">{{offer.role.workSchedule.duration}}</span>
                                        </div>
                                        }
                                        @if(!isPwcPresumptive(offer.project)){
                                        <div class="col-6 flex flex-column">
                                            <span class="text-xs text-primary">Qualification</span>
                                            @if(offer.role?.degrees?.length){
                                              <span class="text-xs">Degrees</span>
                                              @for(degree of offer.role.degrees; track degree){
                                                <span class="text-sm font-medium">{{degree.major}}</span>
                                              }
                                            }
                                            @else {
                                              <span class="text-sm font-medium">N/A</span>
                                            }
                                            @if(offer.role?.criteriaTemplate?.length){
                                              <span class="text-xs">{{'Skills and Experience' | sentenceCase}}</span>
                                              @for(skill of offer.role.criteriaTemplate; track skill){
                                                  <span class="text-sm font-medium">{{skill.name}}</span>
                                                }
                                            }
                                            @if(offer.role?.credentialTemplate?.length){
                                              <span class="text-xs">Credentials</span>
                                              @for(cred of offer.role.credentialTemplate; track cred){
                                                  <span class="text-sm font-medium">{{cred.name}}</span>
                                              }
                                            }
      
                                        </div>
                                        }
      
      
                                        <div class="col-12 xl:ml-auto flex gap-2 xl:flex-wrap xl:justify-content-end">
                                            <p-button styleClass="freshgreen-background" (click)="openAcceptConfirmationModal(offer)" [rounded]="true" size="small" [label]="isPwcPresumptive(offer.project) ? 'available' : 'accept'"></p-button>
                                            <p-button (click)="openRejectionConfirmationModal(offer)" [rounded]="true" size="small" severity="danger" [label]="isPwcPresumptive(offer.project) ? 'not available' : 'reject'"></p-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          }
                                  
                        </div>
                      </p-tabPanel>

                    }
                  </p-tabView>
               </p-panel>
            </div>
            @if(offers.length && !getMobileVisibility()){
              <div class="col-12 lg:col-12 xl:col-4 sm:col-12 job-offer">
                <p-panel [header]="(hasPwcPresumptiveOffers() ? 'Potential project details' : isPWCEnabled ? 'Potential project offers' : 'Job Offers') | sentenceCase" styleClass="p-panel--scondary">
                @for(offer of offers; track offer){
                      <div class="flex flex-column gap-3">
                          <div class="px-3 py-4 mb-5 bg-white">
                              <div class="grid justify-content-between">
                                  <div class="col-6 flex flex-column">
                                    @if(isPWCEnabled){
                                      <span class="text-xs text-primary">Project</span>
                                      <span class="text-sm font-medium">{{offer.project.codeName}}</span>
                                    }
                                    @else{
                                      <span class="text-xs text-primary">Role</span>
                                      <span class="text-sm font-medium">{{offer.role.roleType}}</span>
                                    }                                      
                                  </div>
                                  @if(offer?.role?.workSchedule?.workHours){
                                  <div class="col-6 flex flex-column">
                                      <span class="text-xs text-primary">Hours</span>
                                      <span class="text-sm font-medium">{{offer?.role?.workSchedule?.workHours}}</span>
                                  </div>
                                  }
                                  @if(!isPwcPresumptive(offer.project)){
                                  <div class="col-6 flex flex-column">
                                      <span class="text-xs text-primary">Rate</span>
                                      <span class="text-sm font-medium">${{getFixedValueDigits(offer.role.hourlyRate)}}/hr</span>
                                  </div>
                                  }
                                  @if(offer.role.overtime !== 0){
                                    <div class="col-6 flex flex-column">
                                      <span class="text-xs text-primary">Overtime</span>
                                      @if(offer.role.overTime){
                                        <span class="text-sm font-medium">${{offer.role.overTime}}/hr</span>
                                      } @else {
                                        <span class="text-sm font-medium">N/A</span>
                                      }
                                    </div>
                                  }
                                  <div class="col-6  flex flex-column">
                                    @if(isPWCEnabled){
                                      <span class="text-xs text-primary">{{'Anticipated start Date' | sentenceCase}}</span>
                                    }
                                    @else {
                                      <span class="text-xs text-primary">{{'Start Date' | sentenceCase}}</span>
                                    }
                                    <span class="text-sm font-medium">{{((offer.role.isStarted? offer.positionStarted : offer.role.startDate) | date:'MMM dd, YYYY') || 'Start date not finalized'}} </span>
                                    <span class="text-sm font-medium">{{(offer.role.isStarted? offer.positionStartedTime : offer.role.startTime) }}@if(offer.role.isStarted? offer.positionStartedTime : offer.role.startTime){ - {{offer.role.timezone}}}@else{}</span>
                                  </div>
                                  <div class="col-6 flex flex-column">
                                    <span class="text-xs text-primary">Address</span>
                                    @if(offer?.role?.reviewCenterLocation?.isRemote){
                                    <span class="text-sm font-medium">Remote</span>
                                    }@else{
                                      <span class="text-sm font-medium">{{offer?.role?.reviewCenterLocation?.reviewLocation?.location?.officeName+','}}</span>
                                      <span class="text-sm font-medium">{{offer?.role?.reviewCenterLocation?.reviewLocation?.location?.street+', '+    
                                      offer?.role?.reviewCenterLocation?.reviewLocation?.location?.suiteNo}}</span>
                                      <span class="text-sm font-medium">{{offer?.role?.reviewCenterLocation?.reviewLocation?.location?.city+', '+
                                      offer?.role?.reviewCenterLocation?.reviewLocation?.location?.state +', '+ offer?.role?.reviewCenterLocation?.reviewLocation?.location?.zipCode }}</span>
                                    }
                                    
                                   
                                </div>
                                  <div class="col-6  flex flex-column">
                                    @if(isPWCEnabled){
                                      <span class="text-xs text-primary">Required hours</span>
                                    }
                                    @else {
                                      <span class="text-xs text-primary">Schedule</span>
                                    }
                                      
                                      @if(offer?.role?.workSchedule?.schedule?.weekDays?.willWork){
                                        @if(isPWCEnabled){
                                          <span class="text-sm font-medium">M-F ({{ offer?.role?.workSchedule?.schedule?.weekDays?.generalSelectedHour }})</span>
                                          @if(offer?.role?.workSchedule?.schedule?.weekDays?.potentialWeekendHours){
                                            <span class="text-sm font-medium">Potential weekend hours</span>
                                          }
                                        } @else {
                                          <span class="text-sm font-medium">M-F (
                                            {{
                                              offer?.role?.workSchedule?.schedule?.weekDays?.time?.start?.hour?.toString().padStart(2, '0')
                                            }}:{{
                                              offer?.role?.workSchedule?.schedule?.weekDays?.time?.start?.min?.toString().padStart(2, '0')
                                            }}
                                            {{
                                              offer?.role?.workSchedule?.schedule?.weekDays?.time?.start?.meridiem
                                            }}
                                            --
                                            {{ offer?.role?.workSchedule?.schedule?.weekDays?.time?.end?.hour?.toString().padStart(2, '0') }}:{{
                                              offer?.role?.workSchedule?.schedule?.weekDays?.time?.end?.min?.toString().padStart(2, '0')
                                            }}
                                            {{ offer?.role?.workSchedule?.schedule?.weekDays?.time?.end?.meridiem }}
                                          )</span>
                                        }
                                      }
                                      @if(!isPWCEnabled && offer?.role.workSchedule.schedule.saturday.willWork){
                                        <span class="text-sm font-medium">SAT (
                                          {{
                                            offer?.role?.workSchedule?.schedule?.weekDays?.time?.start?.hour?.toString().padStart(2, '0')
                                          }}:{{
                                            offer?.role?.workSchedule?.schedule?.weekDays?.time?.start?.min?.toString().padStart(2, '0')
                                          }}
                                          {{
                                            offer?.role?.workSchedule?.schedule?.weekDays?.time?.start?.meridiem
                                          }}toString
                                          --
                                          {{ offer?.role?.workSchedule?.schedule?.weekDays?.time?.end?.hour?.toString().padStart(2, '0') }}:{{
                                            offer?.role?.workSchedule?.schedule?.weekDays?.time?.end?.min?.toString().padStart(2, '0')
                                          }}
                                          {{ offer?.role?.workSchedule?.schedule?.weekDays?.time?.end?.meridiem }}
                                        )</span>
                                      }
                                      @if(!isPWCEnabled && offer?.role.workSchedule.schedule.sunday.willWork){
                                        <span class="text-sm font-medium">SUN (
                                          {{
                                            offer?.role?.workSchedule?.schedule?.sunday?.time?.start?.hour?.toString().padStart(2, '0')
                                          }}:
                                          {{
                                            offer?.role?.workSchedule?.schedule?.sunday?.time?.start?.min?.toString().padStart(2, '0')
                                          }}
                                          {{
                                            offer?.role?.workSchedule?.schedule?.sunday?.time?.start?.meridiem
                                          }}
                                          --
                                          {{ 
                                            offer?.role?.workSchedule?.schedule?.sunday?.time?.end?.hour?.toString().padStart(2, '0')
                                          }}
                                          :
                                          {{
                                            offer?.role?.workSchedule?.schedule?.sunday?.time?.end?.min?.toString().padStart(2, '0')
                                          }}
                                          {{ 
                                            offer?.role?.workSchedule?.schedule?.sunday?.time?.end?.meridiem 
                                          }}
                                        )</span>
                                      }
                                  </div>               
   
                      
                                  @if(offer.role.workSchedule.duration){
                                  <div class="col-6 flex flex-column">
                                    @if(isPWCEnabled){
                                      <span class="text-xs text-primary">Anticipated duration</span>
                                    }
                                    @else {
                                      <span class="text-xs text-primary">Duration</span>
                                    }
                                    <span class="text-sm font-medium">{{offer.role.workSchedule.duration}}</span>
                                  </div>
                                  }
                                  @if(!isPwcPresumptive(offer.project)){
                                  <div class="col-6 flex flex-column">
                                      <span class="text-xs text-primary">Qualification</span>
                                      @if(offer.role?.degrees?.length){
                                        <span class="text-xs">Degrees</span>
                                        @for(degree of offer.role.degrees; track degree){
                                          <span class="text-sm font-medium">{{degree.major}}</span>
                                        }
                                      }
                                      @else {
                                        <span class="text-sm font-medium">N/A</span>
                                      }
                                  </div>
                                  @if(offer.role?.criteriaTemplate?.length){
                                    <div class="col-6 flex flex-column">
                                        <span class="text-xs text-primary">{{'Skills and Experience' | sentenceCase}}</span>
                                        @for(skill of offer.role.criteriaTemplate; track skill){
                                            <span class="text-sm font-medium">{{skill.name}}</span>
                                          }
                                    </div>
                                  }
                                  @if(offer.role?.credentialTemplate?.length){
                                    <div class="col-6 flex flex-column">  
                                        <span class="text-xs text-primary">Credentials</span>
                                        @for(cred of offer.role.credentialTemplate; track cred){
                                            <span class="text-sm font-medium">{{cred.name}}</span>
                                        }
                                    </div>
                                  }
                                  }

                                  <div class="col-12 xl:ml-auto flex gap-2 xl:flex-wrap xl:justify-content-end">
                                      <p-button styleClass="freshgreen-background" (click)="openAcceptConfirmationModal(offer)" [rounded]="true" size="small" [label]="isPwcPresumptive(offer.project) ? 'available' : 'accept'"></p-button>
                                      <p-button (click)="openRejectionConfirmationModal(offer)" [rounded]="true" size="small" severity="danger" [label]="isPwcPresumptive(offer.project) ? 'not available' : 'reject'"></p-button>
                                  </div>
                                  </div>
                              </div>
                          </div>
                        }
                </p-panel>               
              </div>
            }
           
            <!-- Accept Offer modal -->
           <p-dialog 
             [modal]="true" 
             draggable="false"
             [(visible)]="visibleAcceptConfirmationModal" 
             [breakpoints]="{ '1199px': '75vw', '767px': '90vw' }" 
             [style]="{ width: '660px' }" >

             <ng-template pTemplate="header">
                 <div class="inline-flex align-items-center justify-content-center gap-2">
                     <span class="font-bold white-space-nowrap">
                         {{(isPwcPresumptive(currentOffer?.project) ? 'Confirm availability' : 'Accept Offer') | sentenceCase}}
                     </span>
                 </div>
             </ng-template>

             <ng-template pTemplate="body">
               <div class="inline-flex align-items-center justify-content-center gap-2">
                   <span class="white-space-nowrap">
                       {{isPwcPresumptive(currentOffer?.project) ? 'Please confirm your availability.' : 'Are you sure you want to accept this offer?'}}
                   </span>
               </div>
           </ng-template>

             <ng-template pTemplate="footer">
               <p-button styleClass="freshgreen-background" [label]="isPwcPresumptive(currentOffer?.project) ? 'available' : 'yes'" size="large" [rounded]="true" (onClick)="accept($event,true)"/>
               <p-button severity="danger" [label]="isPwcPresumptive(currentOffer?.project) ? 'cancel' : 'no'" size="large" [rounded]="true" (onClick)="accept($event)"/>
             </ng-template>
           </p-dialog>

           <!-- Reject Offer modal -->
           <p-dialog 
             [modal]="true" 
             draggable="false"
             [(visible)]="visibleRejectConfirmationModal" 
             [breakpoints]="{ '1199px': '75vw', '767px': '90vw' }" 
             [style]="{ width: '660px' }" >

             <ng-template pTemplate="header">
                 <div class="inline-flex align-items-center justify-content-center gap-2">
                     <span class="font-bold white-space-nowrap">
                         {{(isPwcPresumptive(currentOffer?.project) ? 'Unavailable confirmation' : 'Reject Offer') | sentenceCase}}
                     </span>
                 </div>
             </ng-template>

             <ng-template pTemplate="body">
               <div class="align-items-center justify-content-center gap-2 mb-3">
                   <span class="white-space-nowrap">
                     {{isPwcPresumptive(currentOffer?.project) ? 'Optional, provide a reason for your unavailability.' : 'Why did you Rejected this offer'}}
                   </span>
               </div>
               <div class="align-items-center justify-content-center gap-2">
                 <p-floatLabel>
                   <p-dropdown 
                       [options]="offerRejectReasons"
                       [(ngModel)]="selectedReason"
                       optionLabel="label" 
                       appendTo="body" 
                       inputId="float-label"/>
                     <label for="float-label">Reason</label>
                   </p-floatLabel>
               </div>
           </ng-template>

             <ng-template pTemplate="footer">
               <p-button severity="danger" [label]="isPwcPresumptive(currentOffer?.project) ? 'unavailable' : 'reject offer'" size="large" [rounded]="true" (onClick)="offerReject(true)"/>
               <p-button label="cancel" size="large" [rounded]="true" (onClick)="offerReject()"/>
             </ng-template>
           </p-dialog>
        </div>
    </div>
</div>